
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 21","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M17.393 1.329a1.897 1.897 0 00-.803-.061l-.011.002a12.894 12.894 0 00-6.336 2.882.413.413 0 01-.208.077.768.768 0 00-.07 0 .413.413 0 01-.208-.077c-1.808-1.523-4-2.52-6.338-2.88V1.27l-.01-.002A1.897 1.897 0 001.25 3.15H2h-.75V13.86h.749-.749a1.888 1.888 0 001.641 1.872h.005A11.332 11.332 0 018.83 18.35a1.911 1.911 0 002.34 0l-.42-.543v-.004l.446.526a11.33 11.33 0 015.907-2.594h.004a1.888 1.888 0 001.641-1.873H18h.75V3.149h-.75.75a1.897 1.897 0 00-1.356-1.82zM10.75 16.763a12.831 12.831 0 016.163-2.517h-.002l.098.744-.093-.744h-.003a.388.388 0 00.335-.385V3.148a.397.397 0 00-.447-.395h.007l-.115-.742.104.743h.004a11.394 11.394 0 00-5.631 2.578c-.13.1-.271.182-.42.246v11.186zM9.29 4.738v.001-.001zm.297-.384l.16-.208.01.007.016.013-.13.153a.753.753 0 00-.056.035zM9.25 5.578v11.186a12.831 12.831 0 00-6.164-2.518.388.388 0 01-.336-.385V3.15a.397.397 0 01.447-.394 11.394 11.394 0 015.634 2.577c.13.1.27.182.42.246zM3.197 2.755l-.007-.001.115-.742-.103.743h-.005zm-.111 11.491h.001l-.098.744.094-.744h.003zm7.625-9.509v.001-.001zm-.297-.384l-.161-.208-.01.007-.016.013.13.153c.019.01.038.022.057.035z"}})])
          )
        }
      }
    